export interface NedapInstallation {
  installationId: number;
  installationSerialNumber: string;
  name: string;
  animalType?: string;
  secondaryAnimalType?: string;
  thirdAnimalType?: string;
  status: InstallationStatusType;
}

export interface NedapInstallationsResponse {
  installations: NedapInstallation[];
}

export interface UpdateNedapInstallationMetaDataResponse {
  installationId: number;
}

export interface UpdateNedapInstallationMetaDataRequest {
  installationId: number;
  name: string;
  animalType?: string;
  secondaryAnimalType?: string;
  thirdAnimalType?: string;
}

export interface ResolveAuthorizationCode {
  customerId: number;
  locationId: number;
  authorizationCode: string;
}

export interface InstallationUpsertedReponse {
  installationId: number;
}

export enum InstallationStatusType {
  authenticated = 'Authenticated',
  unauthenticated = 'Unauthenticated',
}

export class AnimalTypeOption {
  value: string;
  label: string;
  secondAnimalTypeOptions?: AnimalTypeOption[];
  thirdAnimalTypeOptions?: AnimalTypeOption[];
}

export interface LeeOAuthentication {
  id: number;
  tokenId: string;
  status: AuthenticationStatusType;
}

export interface LeeOAuthenticationResponse {
  id: number;
  tokenId: string;
  status: AuthenticationStatusType;
}

export enum AuthenticationStatusType {
  authenticated = 'Authenticated',
  unauthenticated = 'Unauthenticated',
}

export interface ApiTokenObject {
  api_token: ApiToken;
}

export interface ApiToken {
  id: string;
  token: string;
  expires_at: Date;
  refresh_token: string;
  refresh_url: string;
}

export interface UpsertLeeOAuthenticationRequest {
  id: string;
  tokenId: string;
  accessToken: string;
  accessTokenExpiryDate: Date;
  refreshToken: string;
  refreshUrl: string;
}

export interface LeeOAuthenticationUpsertedResponse {
  id: number;
}

export interface LeeOAuthenticationUpdatedNotification {
  id: number;
}

export interface ConfigResponse {
  id: string;
  name: string;
  embedUrl: string;
  token: string;
}
